import Vue from 'vue';
import Router from 'vue-router';
import QrLink from '@/components/QRLink/QrLink.vue';
import QrStand from '@/components/QRLink/QrStand.vue';
import QrProduct from '@/components/QRLink/QrProduct.vue';
import QrBadge from '@/components/QRLink/QrBadge.vue';
import QrNone from '@/components/QRLink/QrNone.vue';
import QrCompany from "@/components/QRLink/QrCompany.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/e/:show",
      component: QrLink,
      children: [
        {
          path: 's/:stand',
          component: QrStand
        },
        {
          path: 'p/:product',
          component: QrProduct
        },
        {
          path: 'b/:badge',
          component: QrBadge,
        },
        {
          path: 's/',
          component: QrNone
        },
        {
          path: 'p/',
          component: QrNone
        },
        {
          path: 'b/',
          component: QrNone
        },
        {
          path: 'error',
          name: 'Error',
          component: QrNone
        }
      ]
    },
    {
      path: '/',
      component: QrLink,
      children: [
        {
          path: 'e/:show/b/:badge',
          component: QrBadge,
        },
        {
          path: 'e/:event/b/',
          component: QrNone
        },
        {
          path: 'p/:product',
          component: QrProduct
        },
        {
          path: 'p/',
          component: QrNone
        },
        {
          path: 's/:show/stand/:stand',
          component: QrStand
        },
        {
          path: 's/:show/stand/',
          component: QrNone
        },
        {
          path: 'c/:company',
          component: QrStand
        },
        {
          path: 'c/',
          component: QrNone
        },
        {
          path: 'error',
          name: 'Error',
          component: QrNone
        }
      ]
    }
  ],
});
